import { PrismicLink } from '@prismicio/react'
import NavbarDropdownIcon from '@/components/navbar/NavbarDropdownIcon'

const CompanyDropdownData = ({ data }: { data: any }) => {
  return (
    <div className="dropdown-menu">
      <div className="container-fluid">
        <div className="dropdown-menu-wrapper">
          <div className="company-nav-content col-span-6">
            <h4 className="mb-6">{data.company_text}</h4>

            <div className="company-nav-content-items">
              {(data.company ?? []).map((item: any, index: number) => {
                return (
                  <PrismicLink field={item.company_link_url} key={index}>
                    <div className="company-nav-content-item">
                      <NavbarDropdownIcon field={item.company_icon} />

                      <div className="flex flex-col gap-1">
                        <span className="block font-halyardDisplay text-base font-medium !leading-[110%] tracking-[0.16px] text-primary-ink-100">
                          {item.company_title}
                        </span>
                        <span className="block text-base font-normal !leading-[150%] tracking-[0.16px] text-primary-ink-85">
                          {item.company_description}
                        </span>
                      </div>
                    </div>
                  </PrismicLink>
                )
              })}
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default CompanyDropdownData
